import React from 'react';
import styles from './PhotoUpdate.module.css';
import { PAGE_UPDATE } from '../../Api';
import useFetch from '../../Hooks/useFetch';

const PhotoUpdate = ({ id, html, css, js, atualizar }) => {
  const { loading, request } = useFetch();

  async function handleClick() {

      const formData = new FormData();
    
      if (html) formData.append('html', html); else formData.append('html', '');
      if (css) formData.append('css', css); else formData.append('css', '');
      if (js) formData.append('js', js); else formData.append('js', '');

      
      const { url, options } = PAGE_UPDATE(formData, id);
      const { response } = await request(url, options);
      if (response.ok) atualizar();
      

  }

  return (
    <>
      {loading ? (
        <button className={styles.update} disabled>
          <i className="fa fa-file-code-o"></i>
        </button>
      ) : (
        <button onClick={handleClick} className={styles.update}>
          <i className="fa fa-file-code-o"></i>
        </button>
      )}
    </>
  );
};

export default PhotoUpdate;
